module.exports = __webpack_public_path__ + "static/gold-alt-spirit-e250aa6cf0d20e9bd9b38d013b97d587.jpg";